export function PoMismatchMetric({ label, value, detail, tone }: { label: string; value: string; detail: string; tone: string }) {
  return (
    <div className={`po-mismatch__metric po-mismatch__metric--${tone}`}>
      <div>
        <div className="po-mismatch__metric-label">{label}</div>
        <div className="po-mismatch__metric-value">{value}</div>
        <div className="po-mismatch__metric-detail">{detail}</div>
      </div>
    </div>
  );
}